import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { TicketOrderFormType } from '../components/form-type';

export default function useRecalculate() {
  const { control, setValue } = useFormContext<TicketOrderFormType>();
  const [flightPurchases, otherCost, discount] = useWatch({
    control,
    name: ['flightPurchases', 'otherCost', 'discount'],
  });

  const data = React.useMemo(() => {
    const subtotal = (flightPurchases || []).reduce((prev, fp) => {
      const subtotalGuest =
        fp.flightPurchaseAirlines.reduce(
          (prev, fpa) => prev + (fpa.price || 0),
          0,
        ) * fp.flightPurchaseGuests.length;

      const subtotalAddOns = fp.flightPurchaseAddOns.reduce(
        (prev, fpao) => prev + (fpao.price || 0),
        0,
      );
      return prev + subtotalGuest + subtotalAddOns;
    }, 0);

    const total = subtotal + (otherCost || 0) - (discount || 0);

    setValue('total', total);

    return {
      subtotal,
      otherCost,
      discount,
      total,
    };
  }, [flightPurchases, discount, otherCost, setValue]);

  return data;
}
